export const UNAUTHORIZED_ERROR_TYPE = 401;
export const UNAUTHORIZED_ERROR_MESSAGE = 'EXPIRED_TOKEN'